import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "./Components/baseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import ReactCodeInput from "react-code-input";
const Verify = () => {
    let isShop;
    let shopId;

    if (typeof window !== "undefined") {
        isShop = localStorage.getItem("is_shop");
        shopId = localStorage.getItem("shop_id");
    }
    console.log(shopId);
    useEffect(() => {
        document.title = "پایا | کد تایید";
    }, []);
    const navigate = useNavigate();
    const handlePinChange = (pinCode) => {
        setOtp(pinCode);
    };
    let phone;
    if (typeof window !== "undefined") {
        phone = localStorage.getItem("phone");
    }
    const [otp, setOtp] = useState("");
    const loginHandler = (e) => {
        e.preventDefault();
        let data = new FormData();
        data.append("mobile", phone);
        data.append("code", otp);
        // data.append("code", phone);
        let config = {
            method: "POST",
            url: `${baseUrl}/loginWithMobile`,
            data: data,
        };
        axios(config)
            .then((response) => {
                localStorage.setItem("token", response.data.data.token);
                localStorage.setItem(
                    "user",
                    JSON.stringify(response.data.data)
                );
                shopId == null ||shopId == "null"   
                    ? response.data.data.hasLocation &&
                      response.data.data.hasLocation == true
                        ? document.getElementById("to_home").click()
                        : document.getElementById("to_location").click()
                    : document.getElementById("to_shop").click();
            })
            .catch(function (err) {
                err.response &&
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    function refreshPage() {
        setTimeout(() => {
            window.location.reload(false);
        }, 100);
    }
    const [countDown, setCountDown] = useState(false);
    const [runTimer, setRunTimer] = useState((t) => !t);

    useEffect(() => {
        let timerId;

        if (runTimer) {
            setCountDown(60 * 3);
            timerId = setInterval(() => {
                setCountDown((countDown) => countDown - 1);
            }, 1000);
        } else {
            clearInterval(timerId);
        }

        return () => clearInterval(timerId);
    }, [runTimer]);

    useEffect(() => {
        if (countDown < 0 && runTimer) {
            setRunTimer(false);
            setCountDown(0);
        }
    }, [countDown, runTimer]);
    useEffect(() => {
        if (otp.length > 4) {
            // subHandler();
        }
    }, [otp]);
    const seconds = String(countDown % 60).padStart(2, 0);
    const minutes = String(Math.floor(countDown / 60)).padStart(2, 0);
    const resendHandler = (e) => {
        // let data = new FormData();
        // data.append("phone_number", number);
        // data.append("resend", "resend");
        // let config = {
        //     method: "POST",
        //     url: `${baseUrl}/api/login/driver`,
        //     data: data,
        // };
        // axios(config).then((response) => {
        //     toast.success(response.data.message, {
        //         position: "top-center",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //     });
        // });
    };
    return (
        <div className="container">
            <Link
                to={{ pathname: "/set_location" }}
                id="to_location"
                onClick={refreshPage}
            ></Link>
            <Link
                to={{ pathname: "/" }}
                id="to_home"
                onClick={refreshPage}
            ></Link>
            <Link
                to={{ pathname: `/products/${shopId}` }}
                id="to_shop"
                onClick={refreshPage}
            ></Link>

            <form className="login-main">
                <img src="./assets/images/logo.svg" alt="" />
                <span className="mute-text">
                    کد تایید ارسال شده به {phone} را وارد کنید
                </span>
                <div className="otp-input-fields">
                    <div className="l-t-r">
                        <ReactCodeInput
                            onChange={handlePinChange}
                            pattern="[0-9]*"
                            inputmode="numeric"
                            type="number"
                            fields={6}
                        />
                    </div>
                </div>

                {countDown !== 0 ? (
                    <span className="mute-text" id="code">
                        {minutes}:{seconds}
                        تا ارسال مجدد
                    </span>
                ) : (
                    <span id="resend" className="resend">
                        ارسال مجدد کد
                    </span>
                )}
                <button
                    onClick={loginHandler}
                    className="login-btn"
                    type="submit"
                    id="login-btn"
                >
                    تایید
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
                            stroke="white"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
                <a
                    onClick={() => navigate("/login")}
                    className="login-btn by-username"
                >
                    اصلاح شماره
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
                            stroke="white"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </a>
            </form>
        </div>
    );
};

export default Verify;
